import { FIELD_NAME_SEPARATOR } from '@office-start/telemetry-types';
export function getFlattenedFieldName(fields) {
    return fields.join(FIELD_NAME_SEPARATOR);
}
//# sourceMappingURL=getFlattenedFieldName.js.map